export const SESSION_ESTABLISHED_KEY = 'mgo.bff.sessionEstablished';
export const SESSION_ACTIVITY_EVENT = 'mgo:session-activity';
export const SESSION_REQUEST_STARTED_EVENT = 'mgo:session-request-started';
export const SESSION_REQUEST_FAILED_EVENT = 'mgo:session-request-failed';
export const SESSION_UNAVAILABLE_EVENT = 'mgo:session-unavailable';
export const SESSION_RETURN_ROUTE_KEY = 'mgo.session.returnRoute';

const LEGACY_AUTHENTICATED_KEY = 'authenticated';

/**
 * This browser flag records only that BFF bootstrap completed. It is not an
 * authentication or authorization decision; those remain server-side.
 */
export const markSessionEstablished = () => {
  sessionStorage.setItem(SESSION_ESTABLISHED_KEY, 'true');
  sessionStorage.removeItem(LEGACY_AUTHENTICATED_KEY);
};

export const clearSessionEstablished = () => {
  sessionStorage.removeItem(SESSION_ESTABLISHED_KEY);
  sessionStorage.removeItem(LEGACY_AUTHENTICATED_KEY);
};

export const isSessionEstablished = () => (
  sessionStorage.getItem(SESSION_ESTABLISHED_KEY) === 'true'
);

const createSessionEvent = (name) => {
  if (typeof window.CustomEvent === 'function') {
    return new window.CustomEvent(name);
  }

  const event = document.createEvent('Event');
  event.initEvent(name, false, false);
  return event;
};

export const notifySessionActivity = () => {
  window.dispatchEvent(createSessionEvent(SESSION_ACTIVITY_EVENT));
};

export const notifySessionRequestStarted = () => {
  window.dispatchEvent(createSessionEvent(SESSION_REQUEST_STARTED_EVENT));
};

export const notifySessionRequestFailed = () => {
  window.dispatchEvent(createSessionEvent(SESSION_REQUEST_FAILED_EVENT));
};

export const notifySessionUnavailable = () => {
  clearSessionEstablished();
  window.dispatchEvent(createSessionEvent(SESSION_UNAVAILABLE_EVENT));
};

/**
 * Stores the current route for return after reauthentication.
 * Protected from being overwritten by concurrent failed requests.
 * @param {Object} route - Vue router route object with name, params, query
 */
export const storeReturnRoute = (route) => {
  if (!route || route.name === 'session-unavailable' || route.name === 'home') {
    return;
  }

  const existingRoute = sessionStorage.getItem(SESSION_RETURN_ROUTE_KEY);
  if (existingRoute) {
    return;
  }

  const routeData = {
    name: route.name,
    params: route.params || {},
    query: route.query || {},
    path: route.path,
  };
  sessionStorage.setItem(SESSION_RETURN_ROUTE_KEY, JSON.stringify(routeData));
};

/**
 * Retrieves and clears the stored return route.
 * @returns {Object|null} The stored route object or null
 */
export const getAndClearReturnRoute = () => {
  const routeData = sessionStorage.getItem(SESSION_RETURN_ROUTE_KEY);
  sessionStorage.removeItem(SESSION_RETURN_ROUTE_KEY);

  if (!routeData) {
    return null;
  }

  try {
    return JSON.parse(routeData);
  } catch {
    return null;
  }
};

/**
 * Clears the stored return route without retrieving it.
 */
export const clearReturnRoute = () => {
  sessionStorage.removeItem(SESSION_RETURN_ROUTE_KEY);
};
